import React, { useMemo } from "react"
import { IIconProps, TIconKey } from "./Interfaces"
import AddIcon from "../AddIcon"
import PreviewIcon from "../PreviewIcon"
import CrossIcon from "../CrossIcon"
import SignalIcon from "../SignalIcon"
import UploadIcon from "../UploadIcon"
import ExitIcon from "../ExitIcon"
import AttachmentIcon from "../AttachmentIcon"
import SendIcon from "../SendIcon"
import ArrowUpIcon from "../ArrowUpIcon"
import ArrowDownIcon from "../ArrowDownIcon"
import PencilIcon from "../PencilIcon"
import errorSign from "icons/info-modal-error.svg"
import warningSign from "icons/info-modal-warning.svg"
import infoSign from "icons/info-modal-info.svg"
import PlusIcon from "../PlusIcon"
import SaveIcon from "../SaveIcon"
import LockIcon from "../LockIcon"
import BlankPageIcon from "../BlankPageIcon"
import PersonalizeIcon from "../PersonalizeIcon"
import ItemTypeIcon from "../ItemTypeIcon"
import LayersIcon from "../LayersIcon"
import TableIcon from "../TableIcon"
import FormIcon from "../FormIcon"
import MinusIcon from "../MinusIcon"
import LanguageSelectIcon from "../LanguageSelectIcon"
import CheckIcon from "../CheckIcon"
import Menu from "../Menu"
import ArrowLeft from "../ArrowLeft"
import ArrowLeftEnd from "../ArrowLeftEnd"
import ArrowRight from "../ArrowRight"
import ArrowRightEnd from "../ArrowRightEnd"
import EllipsisIcon from "../EllipsisIcon"
import ArrowDownRoundedIcon from "../ArrowDownRoundedIcon"
import ArrowUpRoundedIcon from "../ArrowUpRoundedIcon"
import EmailIcon from "../EmailIcon"
import DotsIcon from "../DotsIcon"
import CalendarIcon from "../CalendarIcon"

interface Props {
	iconKey: TIconKey | null
	width?: string | number
	height?: string | number
	iconColor?: string
}

const Icon = ({ iconKey, width, height, iconColor }: Props) => {
	let Icon: React.ReactNode = useMemo(() => {
		let iconProps: IIconProps = {
			width,
			height,
			strokeColor: iconColor,
		}

		return iconKey == "add" ? (
			<AddIcon {...iconProps} />
		) : iconKey == "arrowLeft" ? (
			<ArrowLeft {...iconProps} />
		) : iconKey == "arrowLeftEnd" ? (
			<ArrowLeftEnd {...iconProps} />
		) : iconKey == "arrowRight" ? (
			<ArrowRight {...iconProps} />
		) : iconKey == "arrowRightEnd" ? (
			<ArrowRightEnd {...iconProps} />
		) : iconKey == "preview" ? (
			<PreviewIcon {...iconProps} />
		) : iconKey == "cross" ? (
			<CrossIcon {...iconProps} />
		) : iconKey == "signal" ? (
			<SignalIcon {...iconProps} />
		) : iconKey == "upload" ? (
			<UploadIcon {...iconProps} />
		) : iconKey == "exit" ? (
			<ExitIcon {...iconProps} />
		) : iconKey == "attachment" ? (
			<AttachmentIcon {...iconProps} />
		) : iconKey == "send" ? (
			<SendIcon {...iconProps} />
		) : iconKey == "arrow-up" ? (
			<ArrowUpIcon {...iconProps} />
		) : iconKey == "arrow-down" ? (
			<ArrowDownIcon {...iconProps} />
		) : iconKey == "pencil" ? (
			<PencilIcon {...iconProps} />
		) : iconKey == "error-sign" ? (
			<img src={errorSign} />
		) : iconKey == "warning-sign" ? (
			<img src={warningSign} />
		) : iconKey == "info-sign" ? (
			<img src={infoSign} />
		) : iconKey == "blank-page" ? (
			<BlankPageIcon {...iconProps} />
		) : iconKey == "form" ? (
			<FormIcon {...iconProps} />
		) : iconKey == "item-type" ? (
			<ItemTypeIcon {...iconProps} />
		) : iconKey == "language-select" ? (
			<LanguageSelectIcon {...iconProps} />
		) : iconKey == "layers" ? (
			<LayersIcon {...iconProps} />
		) : iconKey == "lock" ? (
			<LockIcon {...iconProps} />
		) : iconKey == "menu" ? (
			<Menu {...iconProps} />
		) : iconKey == "personalization" ? (
			<PersonalizeIcon {...iconProps} />
		) : iconKey == "plus" ? (
			<PlusIcon {...iconProps} />
		) : iconKey == "save" ? (
			<SaveIcon {...iconProps} />
		) : iconKey == "table" ? (
			<TableIcon {...iconProps} />
		) : iconKey == "minus" ? (
			<MinusIcon {...iconProps} />
		) : iconKey == "check" ? (
			<CheckIcon {...iconProps} />
		) : iconKey == "ellipsis" ? (
			<EllipsisIcon {...iconProps} />
		) : iconKey == "arrow-down-rounded" ? (
			<ArrowDownRoundedIcon {...iconProps} />
		) : iconKey == "arrow-up-rounded" ? (
			<ArrowUpRoundedIcon {...iconProps} />
		) : iconKey == "email" ? (
			<EmailIcon {...iconProps} />
		) : iconKey == "dots" ? (
			<DotsIcon {...iconProps} />
		) : iconKey == "calendar" ? (
			<CalendarIcon {...iconProps} />
		) : null
		// Can copy and paste this after last icon to add more icons
		// ) : iconKey == '' ? (
		// 	<SomeIcon {...iconProps} />
	}, [width, height, iconColor])

	return <>{Icon}</>
}

export default Icon
